module.exports = __webpack_public_path__ + "static/media/Mercedes-logo1.696ea63b.png";